(function() {
  function splitHeading() {
    // Find all meet-chippy sections on the page
    const sections = document.querySelectorAll('.meet-chippy');
    
    sections.forEach(function(section) {
      const headingElement = section.querySelector('.meet-chippy__heading');
      
      if (headingElement && !headingElement.dataset.split) {
        const text = headingElement.textContent.trim();
        
        // Split "meet chippy" into two lines
        if (text.toLowerCase().includes('meet') && text.toLowerCase().includes('chippy')) {
          headingElement.innerHTML = '<span class="heading-line-1">meet</span><span class="heading-line-2">chippy</span>';
          headingElement.dataset.split = 'true';
        }
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', splitHeading);
  } else {
    splitHeading();
  }
  
  // Fallback timeout for dynamic content
  setTimeout(splitHeading, 200);
  
  // Handle Shopify section reloads
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', splitHeading);
  }
})();

